import React from "react";
import StdLeaveDetails from "../../components/StudentTabs/StudentLeaveDetails/StdLeaveDetails"

const LeaveDetails = () => {
  return (
    <div>
      
      <StdLeaveDetails/>
    </div>
  );
};

export default LeaveDetails;
